import { msg } from '@lingui/macro';
import { IconPlus } from '@tabler/icons-react';
import type { ImporterDescriptor } from '../../../descriptors/types';

const descriptor: ImporterDescriptor = {
  id: 'productCreationImport',
  status: 'legacy',
  category: 'product-data',
  icon: IconPlus,
  title: msg`New products (legacy)`,
  shortTitle: msg`Add new products (legacy)`,
  whenToUse: msg`Add new products to your portfolio. Superseded by the Product data import, which both creates and updates.`,
  outputDescription: msg`Adds new products to your portfolio (legacy).`,
  intents: ['Legacy new-product creation'],
  keywords: ['legacy', 'new products', 'create', 'add'],
  synonyms: [],
  inputHints: {
    fileTypes: ['xlsx'],
    sampleHeaders: [],
    requiredColumns: [],
  },
};

export default descriptor;
